import { Department } from './company';
import { CostCenter } from './costCentre';
import { ExpenseCode } from './expenseCode';
import { Entity, Id, ServerResponse } from './responses';
import { Subscription } from './subscription';

/** User Models */
export interface User extends Entity {
  name: string;
  first_name: string;
  last_name: string;
  company: string;
  company_id: number;
  role: UserRoles;
  mobile_number: string;
  mobile_country_code: string;
  email: string;
  department: Department;
  employee_code: string;
  cost_center?: CostCenter;
  expense_codes: ExpenseCode[];
  state: UserStates;
  linked_status: UserLinkStatuses;
  account_linked: boolean;
  require_account_linking: boolean;
  customer_code: {
    b2b: string;
    b2c: string;
  };
  account_linking_url?: string;
  subscription: Subscription | null;
  created_at: string;
  updated_at: string;
  is_eligible_for_all_expense_codes: boolean;
  pending_orders?: number;
  cancelled_orders?: number;
  delivered_orders?: number;
  in_progress_orders?: number;
}

export enum UserLinkStatuses {
  Linked = 'linked',
  Unlinked = 'unlinked',
  NotRequired = 'not_required'
}

export enum UserRoles {
  User = 'ROLE_USER',
  Manager = 'ROLE_MANAGER'
}

export enum UserStates {
  Active = 'active',
  Deleted = 'deleted',
  Suspended = 'suspended',
  Invited = 'invited'
}

/** User Response Types */

export interface UserPayload
  extends Pick<
      User,
      | 'first_name'
      | 'last_name'
      | 'email'
      | 'role'
      | 'mobile_number'
      | 'mobile_country_code'
      | 'employee_code'
      | 'is_eligible_for_all_expense_codes'
    >,
    Partial<Pick<User, 'company_id'>> {
  department_id: number;
  cost_center_id: number | null;
  expense_codes: number[];
}

export interface UserEditParams {
  user_id: Id;
  user: UserPayload;
}

export interface UserListResponse extends ServerResponse {
  data: User[];
  total: number;
}

export interface UserUploadResponse extends ServerResponse {
  data: { num_users_uploaded: number };
}

export interface UserGetResponse extends ServerResponse {
  data: User;
}

export interface UserCreateResponse extends ServerResponse {
  data: {
    id: number;
  };
}
export interface UserBulkDeleteResponse extends ServerResponse {
  data: {
    num_users_deleted: number;
    num_users_failed: number;
  };
}

export interface UsersExportResponse extends ServerResponse {
  data: Blob;
}
/** User Service Types */

export enum UserAction {
  Unlink = 'unlink',
  ResendAccountLink = 'resend-link-email',
  ResendInvitation = 'resend-invite',
  Upload = 'upload',
  BuklDelete = 'email'
}
